"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["size", "color", "accessibleTitle"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * @deprecated Use <Icon icon="editPencil" /> instead
 */
var Edit = function Edit(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 25 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#000' : _ref$color,
    _ref$accessibleTitle = _ref.accessibleTitle,
    accessibleTitle = _ref$accessibleTitle === void 0 ? 'Edit' : _ref$accessibleTitle,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    style: {
      width: size,
      height: size,
      minWidth: size,
      minHeight: size
    },
    viewBox: "0 0 30 30"
  }, otherProps), /*#__PURE__*/_react["default"].createElement("title", null, accessibleTitle), /*#__PURE__*/_react["default"].createElement("g", {
    fill: color
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.824 17.9l1.414 1.414 7.071-7.071-1.414-1.415-7.071 7.071zM9.41 19.313l-.327.327-.49 1.843 1.927-.452.304-.304-1.414-1.414zm9.9-9.9l1.413 1.414 1.415-1.414L20.723 8 19.31 9.414zm4.242 1.414L11.53 22.85l-4.917 1.153a.5.5 0 0 1-.597-.616l1.271-4.78L19.31 6.587a2 2 0 0 1 2.829 0L23.552 8a2 2 0 0 1 0 2.828z"
  })));
};
Edit.propTypes = {
  size: _propTypes["default"].number,
  color: _propTypes["default"].string,
  accessibleTitle: _propTypes["default"].string
};
var _default = exports["default"] = Edit;